import { marked } from 'marked'
import DOMPurify from 'isomorphic-dompurify'

export const createMarkup = (input, options = {}) => {
  const renderer = new marked.Renderer()

  if (options.renderInline) {
    // Render input as is, without wrapping <p> tags
    renderer.paragraph = text => text
  }

  if (options.disableAutolink) {
    // Disables autolinking
    renderer.link = text =>
      text
        .replace(/mailto:/g, '')
        .replace(/^https?:\/\//g, '')
        .replace(/www./g, '')
  }

  if (options.openLinksInNewTab) {
    renderer.link = (href, _, text) => {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`
    }
  }

  const config = {
    renderer,
    gfm: true,
    breaks: true,
    headerIds: true,
    mangle: true,
    smartypants: true,
    xhtml: true,
  }

  const parsed = marked(input || '', config)

  const sanitizedHTML = DOMPurify.sanitize(parsed, { ADD_ATTR: ['target', 'style'] })

  return { __html: sanitizedHTML }
}
